export default "__VITE_ASSET__nLxR77lI__"